import classNames from 'classnames'
import * as React from 'react'
import { SiteCountry } from '../data/models/locale'
import { Slink } from './links'

interface LinkProps {
  name: string
  params?: any
  country?: SiteCountry
  children?: React.ReactNode | undefined
}

interface ButtonProps extends LinkProps {
  className?: string
  type?: string
  cutOff?: string
  openInNewTab?: boolean
  textTransform?: string
}

export const SButton: React.FC<ButtonProps> = props => {
  const { className, type, cutOff, textTransform, ...attributes } = props

  const classes = classNames(
    className,
    'srprs-button',
    type ? `type-${type}` : false,
    cutOff ? `cutOff-${cutOff}` : false,
    textTransform ? `text-transform-${textTransform}` : false,
  )

  return <Slink className={classes} {...attributes} />
}
